module.exports = __webpack_public_path__ + "img/utility_a-ti_1.154bed08.jpg";